<template>
    <div
        class="ManualAddress"
    >
        <PageTitle>{{ $t('personal-account.manualAddress.title') }}</PageTitle>
        <h3>{{ $t('personal-account.manualAddress.description') }}</h3>
        <div class="ManualAddress-addressContainer">
            <Block
                class="ManualAddress-containerBlock"
            >
                <div class="row">
                    <div class=" col col-12 col-lg-6">
                        <InputFieldWithLabel
                            v-model="address.street.value"
                            :label="$t('personal-account.manualAddress.street')"
                            :isRequired="true"
                            :errorLabel="getError(address.street.errors)"
                            data-cy="input.street"
                        />
                    </div>
                    <div class=" col col-12 col-lg-6">
                        <InputFieldWithLabel
                            v-model="address.postalCode.value"
                            :label="$t('personal-account.manualAddress.zip')"
                            :isRequired="true"
                            :errorLabel="getError(address.postalCode.errors)"
                            data-cy="input.zipCode"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class=" col col-12 col-lg-6">
                        <InputFieldWithLabel
                            v-model="address.city.value"
                            :label="$t('personal-account.manualAddress.city')"
                            :isRequired="true"
                            :errorLabel="getError(address.city.errors)"
                            data-cy="input.city"
                        />
                    </div>
                    <!--                    <div class="ManualAddress-containerCol">-->
                    <!--                        <CountryInput-->
                    <!--                            v-model="address.country.value"-->
                    <!--                            :label="$t('personal-account.manualAddress.country')"-->
                    <!--                            :isRequired="true"-->
                    <!--                        />-->
                    <!--                    </div>-->
                </div>
                <div class=" row">
                    <div class="ManualAddress-submitContainer col col-12 col-lg-10">
                        <RoundedButton
                            :label="$t('personal-account.manualAddress.save')"
                            type="reversed"
                            class="ManualAddress-containerSubmit"
                            data-cy="button.save"
                            @buttonClicked="submit"
                        />
                    </div>
                </div>
            </Block>
        </div>
    </div>
</template>

<script>
import {
    Block, InputFieldWithLabel, RoundedButton, CountryInput
} from '@free2move/vuejs-components';
import PageTitle from "@/components/PageTitle.vue";
import {required, validate} from "@free2move/vuejs-components/validators.js";
import * as mutationTypes from "@/store/mutation-types";
import * as actionTypes from "@/store/action-types";
import Component from "vue-class-component";
import Vue from "vue";

@Component({
    components: {
        PageTitle,
        Block,
        InputFieldWithLabel,
        RoundedButton,
        CountryInput
    }
})
export default class ManualAddress extends Vue {
    data() {
        return {
            address: {
                street: {
                    value: '',
                    validators: [required],
                    errors: []
                },
                city: {
                    value: '',
                    validators: [required],
                    errors: []
                },
                postalCode: {
                    value: '',
                    validators: [required],
                    errors: []
                },
                // country: {
                //     value: '',
                //     validators: [required],
                //     errors: []
                // },
            },
            global: {
                errors: []
            }
        }
    }
    mounted() {
        this.$store.dispatch(actionTypes.GET_PROFILE, { callback: this.serializeAddress});
    }

    getStreet(data) {
        return (data.number && data.street) ? `${data.number} ${data.street}` : data.name;
    }

    serializeAddress(response) {
        this.address.street.value = response.data.address?.street || '';
        this.address.city.value = response.data.address?.city || ''
        this.address.postalCode.value = response.data.address?.postalCode || '';
        // this.address.country.value = response.data.address.country;
    }

    submit() {
        this.resetErrors();
        const manualAddress = {
            street: this.address.street,
            city: this.address.city,
            postalCode: this.address.postalCode,
            // country: this.address.country
        };
        validate(manualAddress)
            .then(() => {
                this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, true);
                this.$store.dispatch(actionTypes.UPDATE_USER_ADDRESS, {
                    data: {
                        street: manualAddress.street.value,
                        city: manualAddress.city.value,
                        postalCode: manualAddress.postalCode.value,
                        // country: manualAddress.country.value,
                    },
                    callback: ({data}) => {
                        this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
                        if (data) {
                            this.$router.push({name: 'personalAccount'});
                        } else {
                            this.global.errors.push('anErrorOccurred');
                        }
                    }
                })
            })
            .catch((errors)=>{
                this.address.street.errors = errors.street;
                this.address.postalCode.errors = errors.postalCode;
                this.address.city.errors = errors.city;
                // this.address.country.errors = errors.country;
            })
            .finally(()=>{
                this.$store.commit(mutationTypes.UPDATE_SHOW_TRANSPARENT_GLOBAL_LOADER, false);
            });
    }
    getError(errors) {
        return errors?.length > 0 ? this.$t('personal-account.manualAddress.error.' + errors[0]) : ''
    }
    resetErrors() {
        this.address.street.errors = [];
        this.address.postalCode.errors = [];
        this.address.city.errors = [];
        // this.address.country.errors = [];
        this.global.errors = [];
    }
}
</script>
<style lang="scss" scoped>
.ManualAddress{
    width: 100%;

    h3 {
        font-family: $font-lato;
        font-style: normal;
        font-weight: 400;
        font-size: 22px;
        line-height: 26px;
        color: #FFFFFF;
        mix-blend-mode: normal;
        opacity: 0.7;
    }

    &-progressBar{
        width: 300px;
    }
    &-serviceAvailability{
        margin-top: 20px;
    }

    &-container{
        margin-top: 36px;
    }

    &-containerBlock{
        padding: 28px;
        margin-top: 60px;
    }

    &-containerTitle{
        color: $color-f2m-purple;
        font-size: 22px;
        font-weight: 400;
        margin: 0;
        margin-bottom: 36px;
    }

    &-containerSubmit {
        width: 70%;
        @media only screen and (max-width: $f2m-desktop-breakpoint) {
            width: 100%;
        }
    }

    .col {
        margin-bottom: 28px;
    }

    &-submitContainer.col {
        margin-bottom: 0;
    }
}
</style>
